// extracted by mini-css-extract-plugin
export default {"container":"JOMS","header":"lcAJ","divider":"ndC0","infoWrapper":"eRiA","item":"SJGL"};